"use strict";

function setLesninaWidget() {
  window.prepareWidget('lesnina');
}
['DOMContentLoaded', 'PremiumArticleContentLoaded'].forEach(event => {
  document.addEventListener(event, setLesninaWidget);
});